module.exports = __webpack_public_path__ + "static/img/1.968bb401.jpg";